'use strict';

/**
 * @author Maxim Seredkin
 */

export default ['$scope', '$uibModalInstance', 'okved', 'okveds',
                function($scope, $modalInstance, okved, okveds) {
                    $scope.setOkved = setOkved;
                    $scope.ok = ok;
                    $scope.cancel = cancel;

                    $scope.okved = okved;
                    $scope.okveds = angular.copy(okveds);

                    // region Function

                    function setOkved(okved) {
                        $scope.okved = okved;
                    }

                    function ok() {
                        $modalInstance.close(Array.isArray($scope.okveds) ? $scope.okveds : $scope.okved);
                    }

                    function cancel() {
                        $modalInstance.dismiss();
                    }

                    // endregion
                }];
